import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.29 31.301c-.217-1.297-.24-2.65-.244-3.958-.004-1.147.121-2.27.441-3.367.755-2.588 2.42-4.774 4.486-6.433 2.954-2.37 6.651-3.81 10.332-4.616a37.333 37.333 0 0 1 8.728-.873c4.698-.095 9.622.664 14 2.538 3.902 1.67 7.673 4.373 9.25 8.501.998 2.612.849 5.505.494 8.205-.06.655-.041 1.337-.35 1.931-.236.456-.632.776-1.1.97-1.084.452-2.426.39-3.576.216-1.206-.183-2.362-.594-3.497-1.05-1.148-.46-2.357-.89-3.259-1.787-.7-.696-.958-1.49-.977-2.448-.019-.985.007-1.963-.13-2.943-.317-2.277-1.397-4.441-2.98-6.117-2.016-2.133-4.989-3.422-7.875-3.491-4.642.112-9.217 3.328-10.579 7.835-.31 1.03-.402 2.107-.378 3.187.017.791.15 1.629.019 2.411-.376 2.238-3.116 3.089-4.94 3.72-1.249.43-2.542.74-3.873.79-1.1.041-2.585.025-3.386-.908C.334 32.96.365 32.102.291 31.3Z",
    fill: "currentColor"
  }));
};

var SvgHangUp = styled(SvgComponent).withConfig({
  displayName: "HangUp__SvgHangUp",
  componentId: "sc-1rxq485-0"
})(["", " ", ""], size, color);
export default SvgHangUp;